import React from 'react';
import { Image, Platform, TouchableOpacity } from 'react-native';
import { wp } from '../../utils/responsiveScreen';
export const HeaderBackButton = ({
  onPress,
  iconStyle
}) => {
  return /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: onPress,
    style: {
      marginLeft: Platform.OS === 'android' ? wp(3.5) : 0
    }
  }, /*#__PURE__*/React.createElement(Image, {
    source: require('../../assets/icons/arrow-left.png'),
    style: [{
      width: 26,
      height: 26
    }, Platform.OS === 'ios' ? {
      marginLeft: wp('3.5%')
    } : {
      paddingLeft: wp(2)
    }, iconStyle]
  }));
};
//# sourceMappingURL=index.js.map